import $ from 'jquery';

const btnClickOurStory = () => {
	const el = {
		btn: '#btnReadOurStory',
		section: '#secOurStory',
	};

	if ($(el.btn).length === 0 || $(el.section).length === 0) return;

	const init = () => {
		bindEvent();
	};

	const bindEvent = () => {
		$(el.btn).on('click', (e) => {
			e.preventDefault();
			$(el.btn).toggleClass('is-active');
			$(el.section).toggleClass('is-active');
		});
	};

	init();
};

try {
	btnClickOurStory();
} catch (error) {
	console.error('btnClickOurStory', error);
}
